import { Controller } from '@hotwired/stimulus';
import { debounce } from 'throttle-debounce';

export default class extends Controller {
	static targets = ['legendaItem', 'container', 'header'];

	connect() {
		var anchors = document.querySelectorAll('.anchor');

        const refreshLegenda = debounce(100, () => {
            const ids = [];

            // Save all ids if the bounds are scrolled past this anchor
            anchors.forEach((anchor) => {
                const bounds = anchor.getBoundingClientRect();
                const id = anchor.getAttribute('id');

                if(bounds.bottom - 50 < 0) {
                    ids.push(id);
                }
            });

            // Remove legenda if on the header
            if(ids.length === 0) {
                if(!this.containerTarget.classList.contains('-translate-y-full')) {
                    this.containerTarget.classList.add('-translate-y-full')
                }
            } else {
                if(this.containerTarget.classList.contains('-translate-y-full')) {
                    this.containerTarget.classList.remove('-translate-y-full')
                }
            }

            // Check if legenda href is the same as the anchor id and set conent in the fixed legenda
            this.legendaItemTargets.forEach((item) => {
                const href = item.getAttribute('href');

                if(href.substring(1) == ids[ids.length - 1]) {
                    this.headerTarget.innerHTML = item.innerHTML;
                }
            });
        });

        document.addEventListener("scroll", (event) => {
            refreshLegenda();
        });
	}
}
